import React from 'react';
import {
    Table,
    Row,
    Spin,
} from 'antd';

import { actions, asyncGetMonitorList,asyncGetEvs} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';




class localResourceRate extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        //this.props.asyncGetEvs();//表示mapDispatchToProps中读取
        //this.props.asyncGetMonitorList(); 监测公司
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGetEvs();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGetEvs();
    };

    
    handleSearch(input){
        //将子组件对象绑定到父组件的$child属性，这个属性名可以自己随便起
        this.$child = input;
    }
    

    render() {
        let {uiStatus ,pagination,rateList} = this.props;
        //console.log('hA-',rateList);
        let { isLoading } = uiStatus;
        const columnsEv = [
            {
                title: 'taskId',
                dataIndex: 'taskId',
                key: 'taskId',
            },
            {
                title: '广告位名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: 'PS',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '无素材',
                dataIndex: 'noDataCount',
                key: 'noDataCount',
            },
            {
                title: '实际分配',
                dataIndex: 'assignActually',
                key: 'assignActually',
            },
            {
                title: '无代理',
                dataIndex: 'noProxyCount',
                key: 'noProxyCount',
            },
            {
                title: '无设备',
                dataIndex: 'noDeviceCount',
                key: 'noDeviceCount',
            },
            {
                title: '系统错误',
                dataIndex: 'systemErrorCount',
                key: 'systemErrorCount',
            },
            {
                title: '素材返回率(%)',
                dataIndex: 'localResourceRate',
                key: 'localResourceRate',
                sorter: (a, b) => a.localResourceRate - b.localResourceRate,
            },
            ];
      
        let { totalPage, current, pageSize } = pagination;
        
        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props}  handleSearch={this.handleSearch.bind(this)} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                 
                            <Table
                                columns={columnsEv}
                                dataSource={rateList}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                      
                     {/* <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={totalPage}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['10', '15', '20', '40','100','500','1000']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row> */}
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    rateList: state.localResourceRate.rateList,
    pagination: state.localResourceRate.pagination,
    uiStatus: state.localResourceRate.uiStatus,
   
});
const mapDispatchToProps = dispatch => ({
    asyncGetEvs: () => dispatch(asyncGetEvs()),
    
});
export default connect(mapStateToProps, mapDispatchToProps)(localResourceRate);






// WEBPACK FOOTER //
// ./pages/monitor/localResourceRate/index.js